import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    {
      /* <Title text="Projeler"> {"⏳"} {"Yakında"} </Title>*/
    }
    <ul>
      <li parentName="ul"></li>
      <li parentName="ul"></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      